/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { InstagramEmbed } from "react-social-media-embed";
import { Helmet } from "react-helmet-async";

const Bridal = () => {

  const instagramPosts = [
   "https://www.instagram.com/p/DUGESOwkTGp/",
    "https://www.instagram.com/p/DF_rFzrSFyw/",
    "https://www.instagram.com/p/DHpOMTdtx7B/",
    "https://www.instagram.com/p/DHpNbvJNZUh/",
    "https://www.instagram.com/p/Co60CdWvseQ/",
    "https://www.instagram.com/p/Cg82vuKviU4/",
    "https://www.instagram.com/p/Cg6IByoPQwQ/",
  ];

  return (
    <>
    <Helmet>

  <title>
    Best Bridal Makeup Artist in Prayagraj |
    Arson's Beauty Zone
  </title>

  <meta
    name="description"
    content="
    Explore real bridal makeup transformations,
    wedding looks and luxury bridal beauty
    makeovers by Arson's Beauty Zone in Prayagraj.
    "
  />

</Helmet>
      {/* INSTAGRAM GALLERY */}
      <section
        style={{
          padding: "140px 0",
          background:
            "linear-gradient(to bottom,#050505,#111111)",
          position: "relative",
          overflow: "hidden",
        }}
      >

        {/* GLOW */}
        <div
          style={{
            position: "absolute",
            width: "500px",
            height: "500px",
            background:
              "radial-gradient(circle,rgba(216,176,110,0.18),transparent 70%)",
            filter: "blur(70px)",
            top: "-120px",
            right: "-120px",
          }}
        />

        <div className="container text-center">

          <p
            className="section-tag"
            style={{
              fontSize: "20px",
              textDecoration: "underline",
              color:"white",
              textDecorationColor: "#d8b06e",
            }}
          >
            INSTAGRAM GALLERY
          </p>

          <h2
            className="luxury-heading section-heading"
            style={{
              fontSize: "clamp(55px,6vw,85px)",
              color: "#fff",
            }}
          >
            Real Bridal Transformations
          </h2>

          <p
            style={{
              color: "rgba(255,255,255,0.72)",
              maxWidth: "720px",
              margin: "20px auto 70px",
              lineHeight: "2",
            }}
          >
            Explore real bridal makeovers and luxury beauty
            transformations from our official Instagram.
          </p>

          <div className="row g-4 justify-content-center">

            {instagramPosts.map((post, index) => (

              <div
                className="col-lg-4 col-md-6"
                key={index}
              >
                <div
                  style={{
                    background:
                      "linear-gradient(to bottom,#171717,#0b0b0b)",

                    padding: "18px",

                    borderRadius: "35px",

                    border:
                      "1px solid rgba(216,176,110,0.14)",

                    boxShadow:
                      "0 25px 70px rgba(0,0,0,0.45)",

                    transition: ".45s ease",
                  }}
                >
                  <InstagramEmbed
                    url={post}
                    width={"100%"}
                  />
                </div>
              </div>

            ))}

          </div>

          {/* BUTTON */}
          <a
            href="https://www.instagram.com/arsonsbeautyzone/"
            target="_blank"
            rel="noreferrer"
            style={{
              background:
                "linear-gradient(to right,#d8b06e,#f7d79b)",

              color: "#111",

              border: "none",

              padding: "18px 45px",

              borderRadius: "60px",

              fontWeight: "700",

              display: "inline-block",

              textDecoration: "none",

              marginTop: "70px",
            }}
          >
            View More On Instagram
          </a>

        </div>
      </section>
    </>
  );
};

export default Bridal;